import React, { Component } from 'react';
import { Card, Col, Row, Typography, Form, Input, Button, Radio, Space, Table, Checkbox, Select, Dropdown, Affix } from 'antd';
import logo from '../images/swan-logo.png';
import { IoMdAdd } from 'react-icons/io';
import { SWANProperties, themeColor } from '../constants';
import PDFSwanGeneral from '../pdf/Swan General - Guidelines on Beneficial Ownership Declaration Form.pdf';
import PDFSwanLife from '../pdf/Swan Life - Guidelines on Beneficial Ownership Declaration Form.pdf';
import PDFSwanPensions from '../pdf/Swan Pensions - Guidelines on Beneficial Ownership Declaration Form.pdf';
import PDFSwanSecurities from '../pdf/Swan Securities - Guidelines on Beneficial Ownership Declaration Form.pdf';
import PDFSwanSpecialRisks from '../pdf/Swan Special Risks - Guidelines on Beneficial Ownership Declaration Form.pdf';
import PDFSwanCorporateAdvisors from '../pdf/Swan Corporate Advisors - Guidelines on Beneficial Ownership Declaration Form.pdf';
import PDFSwanActuarialServices from '../pdf/Swan Actuarial Services - Guidelines on Beneficial Ownership Declaration Form.pdf';
import PDFSwanReinsurance from '../pdf/Swan Re PCC - Guidelines on Beneficial Ownership Declaration Form.pdf';
import PDFHowToFill from '../pdf/BENEFICIAL OWNERSHIP DECLARATION ONLINE FORM - STEPS TO FOLLOW.pdf';
import { FaFilePdf } from 'react-icons/fa';

const { Title, Text } = Typography
const { Option } = Select


// const guidelinesLabel = (
//     <Text>
//         Please refer to the <span style={{ color: 'blue' }}>Guidelines on Beneficial Ownership </span> as a guidance note on how to fill in this form
//     </Text>
// )


const items = [
    // {
    //     key: '2',
    //     label: (
    //         <a target="_blank" rel="noopener noreferrer" href={PDFHowToFill}>
    //             How to fill BO Form
    //         </a>
    //     )
    // },
    {
        key: '1',
        label: 'Guidelines for',
        children: [
            {
                key: '1-1',
                label: (
                    <a target="_blank" rel="noopener noreferrer" href={PDFSwanGeneral}>
                        Swan General Ltd
                    </a>
                ),
            },
            {
                key: '1-2',
                label: (
                    <a target="_blank" rel="noopener noreferrer" href={PDFSwanLife}>
                        Swan Life Ltd
                    </a>
                )
            },
            {
                key: '1-3',
                label: (
                    <a target="_blank" rel="noopener noreferrer" href={PDFSwanPensions}>
                        Swan Pensions Ltd
                    </a>
                )
            },
            {
                key: '1-4',
                label: (
                    <a target="_blank" rel="noopener noreferrer" href={PDFSwanSecurities}>
                        Swan Securities Ltd
                    </a>
                )
            },
            {
                key: '1-5',
                label: (
                    <a target="_blank" rel="noopener noreferrer" href={PDFSwanSpecialRisks}>
                        Swan Special Risks Ltd
                    </a>
                )
            },
            {
                key: '1-6',
                label: (
                    <a target="_blank" rel="noopener noreferrer" href={PDFSwanActuarialServices}>
                        Swan Actuarial Services Ltd
                    </a>
                )
            },
            {
                key: '1-7',
                label: (
                    <a target="_blank" rel="noopener noreferrer" href={PDFSwanCorporateAdvisors}>
                        Swan Corporate Advisors Ltd
                    </a>
                )
            },
            {
                key: '1-8',
                label: (
                    <a target="_blank" rel="noopener noreferrer" href={PDFSwanCorporateAdvisors}>
                        Swan Forex Ltd
                    </a>
                )
            },
            {
                key: '1-9',
                label: (
                    <a target="_blank" rel="noopener noreferrer" href={PDFSwanReinsurance}>
                        Swan Reinsurance PCC
                    </a>
                )
            },
        ],
    }
];

class BOForm extends Component {

    constructor(props) {
        super(props);
        this.BOFOrm = React.createRef();
        this.state = {
            isSeniorManagingTitleDisabled: true,
            selectedSwanEntity: ''
        }
    }
    toggleSeniorManagingOfficialTitle = async () => {
        await this.props.resetBOTable();
        if (this.BOFOrm.current.getFieldValue('eis3PersonBoType') === 'val1') {
            this.setState({
                isSeniorManagingTitleDisabled: true
            })
        } else {
            this.setState({
                isSeniorManagingTitleDisabled: false
            })
            await this.BOFOrm.current.setFieldsValue({
                eis4SeniorManagingOfficialTitle: '',
            });

        }
    }

    handleSelectSWANEntity = async (value) => {
        await this.setState({
            selectedSwanEntity: value
        })
    }
    render() {
        return (
            <Card>
                <div style={{ position: 'absolute', top: 0, right: 10, marginRight: 8 }}>
                    <Affix offsetTop={5}>
                        <Dropdown
                            menu={{
                                items,
                            }}
                            placement='bottomRight'
                        >
                            <Typography.Title
                                level={5}
                                style={{
                                    background: '#00468b',
                                    cursor: 'pointer',
                                    color: 'white',
                                    padding: '7px 12px 7px 12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    borderRadius: 20,
                                    border: '1px solid white',
                                    boxShadow: '3px 2px 4px 0px rgba(0,0,0,0.24)',
                                    // -webkit-box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.24),
                                    // -moz-box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.24),
                                }}
                            >
                                <FaFilePdf color='white' size={18} style={{ margin: '0px 4px 0px 4px', padding: 0 }} />
                                <span>
                                    Guidelines
                                </span>
                            </Typography.Title>
                        </Dropdown>

                    </Affix>

                </div>

                <Row style={{ marginTop: 15, marginBottom: 5 }}>
                    <Col>
                        <div className="logo">
                            <img alt="SWAN" src={logo} height={35} />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div>
                            <Title level={3} style={{ color: '#00468b', fontWeight: 20 }}>BENEFICIAL OWNERSHIP DECLARATION FORM</Title>
                            <Text strong>(Please complete all the relevant sections below in relation to Beneficial Ownership of the client)</Text>
                        </div>
                    </Col>
                </Row>
                <p style={{ margin: 20 }} />
                <Row>
                    <Col>
                        <Title level={5} style={{ background: '#00468b', color: 'white', padding: '1px 9px 1px 9px' }}>ENTITY IDENTIFICATION SECTION</Title>
                    </Col>
                </Row>
                <Row style={{ marginTop: 5 }}>
                    <Form
                        layout='horizontal'
                        name="BOForm"
                        ref={this.BOFOrm}
                        labelWrap={true}
                        labelAlign={'left'}
                        labelCol={{ span: 8 }}
                        // wrapperCol={{ span: 16 }}
                        initialValues={{ remember: true }}
                        onFinish={this.props.onSubmitForm}
                        onFinishFailed={this.props.onSubmitFormFailed}
                        requiredMark={false}
                        autoComplete="off"
                        style={{ paddingLeft: 9 }}
                        colon={false}
                    >
                        <Form.Item
                            name='eis1FullName'
                            label={
                                <Text strong>
                                    Full Name of Legal Person/Legal Arrangement "client" (Entity Name):
                                    {/* Full Name of Legal Person/Legal Arrangement: “client” (Entity Name) */}
                                </Text>
                            }
                            rules={[{ required: true, message: 'Please enter full name' }]}
                        >
                            <Input placeholder="Enter full name" />
                        </Form.Item>
                        <Form.Item
                            name='eis2RegistrationNo'
                            label={
                                <Text strong>
                                    Business Registration Number of Client:
                                </Text>
                            }
                            rules={[{ required: true, message: 'Please enter registration number' }]}
                        >
                            <Input placeholder="Enter registration number" />
                        </Form.Item>
                        <Text strong>
                            Please tick one of the relevant boxes below:
                        </Text>
                        <Form.Item
                            name="eis3PersonBoType"
                            style={{ width: '100%', marginTop: 10 }}
                            rules={[{ required: true, message: 'Please tick one below' }]}
                        >
                            <Radio.Group
                                style={{ width: '100%' }}
                                onChange={this.toggleSeniorManagingOfficialTitle}
                            >
                                <Space direction='vertical' size='small'>
                                    <Radio
                                        value="val1"
                                    >
                                        The natural person(s) listed below is/are the Beneficial Owner(s) who exercises/exercise ultimate control over the client.
                                    </Radio>
                                    <Radio
                                        value="val2"
                                    >
                                        The natural person(s) listed below is/are the Senior Managing Official(s) who exercises/exercise ultimate control over the client.
                                    </Radio>
                                </Space>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item
                            name='eis4SeniorManagingOfficialTitle'
                            label={
                                <Text strong>
                                    Title of the Senior Managing Official:
                                </Text>
                            }
                            rules={!this.state.isSeniorManagingTitleDisabled ? [{ required: true }] : [{ required: false }]}
                        >
                            <Input
                                placeholder="Enter title"
                                disabled={this.state.isSeniorManagingTitleDisabled}
                            />
                        </Form.Item>
                        <div style={{ display: 'flex', justifyContent: 'end', marginBottom: 5 }}>
                            <Button
                                type='default'
                                onClick={this.props.triggerShowNewBOModal}
                                style={{ display: 'flex', alignItems: 'center', border: '1px solid #00468b', color: '#00468b' }}
                                disabled={this.BOFOrm.current && this.BOFOrm.current.getFieldValue('eis3PersonBoType') !== null ? false : true}
                            >
                                <IoMdAdd size={16} color='#00468b' style={{ marginRight: 5 }} /> Add New Owner
                            </Button>
                        </div>
                        <Table
                            className='BOs-form'
                            bordered
                            loading={this.props.isLoadingBOTable}
                            dataSource={this.props.defaultBOData}
                            columns={this.props.defaultBOColumns}
                        />

                        <Text strong style={{ fontSize: 12 }}>
                            Please submit the National Identity Card/Passport and Proof of Residential Address not older than 3 months of the Beneficial
                            Owner(s)/Senior Managing Official(s) for whom mention has been made in the table above.
                        </Text>

                        <div style={{ padding: 10, border: '1px solid lightgray', marginTop: 25 }}>
                            <Form.Item
                                name="eis5Checkbox"
                                style={{ width: '100%', marginTop: 10 }}
                                rules={[{ required: true, message: 'Please sign terms/agreement' }]}
                            >
                                <Checkbox.Group>
                                    <Checkbox value='isAgree'>
                                        I, the undersigned, for and on behalf of the client, hereby acknowledge and confirm that the information provided above is true,
                                        correct and complete to the best of my knowledge and belief.
                                    </Checkbox>
                                </Checkbox.Group>
                            </Form.Item>

                            <Form.Item
                                name='eis6CheckboxCompany'
                                label={
                                    <Text strong style={{ textTransform: 'uppercase' }}>
                                        SELECT THE CONCERNED SWAN ENTITY:
                                    </Text>
                                }
                                rules={[{ required: true, message: 'Please select company' }]}
                            >
                                <Select
                                    style={{
                                        width: 220,
                                    }}
                                    placeholder='Select company'
                                    onChange={this.handleSelectSWANEntity}
                                    showSearch
                                >
                                    {SWANProperties.map((prop, index) => {
                                        return (
                                            <Option key={index} value={prop}>{prop}</Option>
                                        )
                                    })}
                                </Select>
                            </Form.Item>
                            <Form.Item
                                name='eis7SignatoryFullName'
                                label={
                                    <Text strong>
                                        FULL NAME OF AUTHORISED SIGNATORY
                                    </Text>
                                }
                                rules={[{ required: true, message: 'Please enter full name of signatory' }]}
                            >
                                <Input placeholder="Enter full name" />
                            </Form.Item>
                            <Form.Item
                                name='eis8Designation'
                                label={
                                    <Text strong>
                                        DESIGNATION/POSITION
                                    </Text>
                                }
                                rules={[{ required: true, message: 'Please enter designation/position' }]}
                            >
                                <Input placeholder="Enter full name" />
                            </Form.Item>
                        </div>
                        {/* <Text style={{ fontSize: 13 }}>
                            {
                                this.state.selectedSwanEntity === 'Swan General Ltd' ?
                                    <a rel="noreferrer" href={PDFSwanGeneral} style={{ textDecoration: 'none', color: 'black' }} target='_blank'>
                                        {guidelinesLabel}
                                    </a>
                                    :
                                    this.state.selectedSwanEntity === 'Swan Life Ltd' ?
                                        <a rel="noreferrer" href={PDFSwanLife} style={{ textDecoration: 'none', color: 'black' }} target='_blank'>
                                            {guidelinesLabel}
                                        </a>
                                        :
                                        this.state.selectedSwanEntity === 'Swan Pensions Ltd' ?
                                            <a rel="noreferrer" href={PDFSwanPensions} style={{ textDecoration: 'none', color: 'black' }} target='_blank'>
                                                {guidelinesLabel}
                                            </a>
                                            :
                                            this.state.selectedSwanEntity === 'Swan Securities Ltd' ?
                                                <a rel="noreferrer" href={PDFSwanSecurities} style={{ textDecoration: 'none', color: 'black' }} target='_blank'>
                                                    {guidelinesLabel}
                                                </a>
                                                :
                                                this.state.selectedSwanEntity === 'Swan Special Risks Company Limited' ?
                                                    <a rel="noreferrer" href={PDFSwanSpecialRisks} style={{ textDecoration: 'none', color: 'black' }} target='_blank'>
                                                        {guidelinesLabel}
                                                    </a>
                                                    :
                                                    this.state.selectedSwanEntity === 'Swan Actuarial Services Ltd' ?
                                                        <a rel="noreferrer" href={PDFSwanActuarialServices} style={{ textDecoration: 'none', color: 'black' }} target='_blank'>
                                                            {guidelinesLabel}
                                                        </a>
                                                        :
                                                        this.state.selectedSwanEntity === 'Swan Corporate Affairs Ltd' ?
                                                            <a rel="noreferrer" href={PDFSwanCorporateAdvisors} style={{ textDecoration: 'none', color: 'black' }} target='_blank'>
                                                                {guidelinesLabel}
                                                            </a>
                                                            :
                                                            <br />
                            }
                        </Text> */}

                        <Row>
                            <Col xs={0} sm={0} md={0} lg={5}></Col>
                            <Col xs={24} sm={24} md={24} lg={14} style={{ marginTop: 25 }}>
                                <Form.Item style={{ width: '100%' }}>
                                    <Button
                                        className='buttonColorChange'
                                        style={{ width: '100%', backgroundColor: themeColor, borderRadius: 15 }}
                                        type="primary"
                                        htmlType="submit"
                                        size='large'
                                        loading={this.props.isSubmittingForm}
                                        disabled={this.props.defaultBOData.length > 0 ? false : true}
                                    // onClick={this.props.onSubmitForm}
                                    >
                                        Submit
                                    </Button>
                                </Form.Item>
                            </Col>
                            <Col xs={0} sm={0} md={0} lg={5}></Col>
                        </Row>

                    </Form>
                </Row>

            </Card >
        );
    }
}

export default BOForm;